import React, { Component } from 'react';
import { Container, Grid, Segment, Header, Table, Label, Button, Image, List, Icon, Loader } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import { getVisitDetailAction, getVisitsListAction } from '../../actions';
import { generateInvoice } from '../../actions/productsActions';
import Moment from  'moment';
import CommonUtility from '../../utils/CommonUtility';

class PanelVisitDetailPage extends Component {
    state = {
        selectedAttachmentId: null,
        viewUrl: null,
        processingClaim:[],
        openDeleteDialog: false,
        deleteThisClaim: false,
        deleteThisClaimResult: null,
        mimeType: null,
        showDetailIncAmount: false,
        detailPanelVisit: null
    }

    componentDidMount() {
        const { accessToken, records } = this.props.user;
        const { filterByClaimant } = this.props.claimFilterOptions;
        let visitId = this.props.match.params.visitId;
        const memberRecordId = filterByClaimant ? filterByClaimant : records[0].uuid;

        if(visitId !== 'detail'){
            this.props.getVisitDetailAction({
                accessToken,
                memberRecordId, 
                visitId
            });
    
            this.props.generateInvoice(visitId, memberRecordId, 'MYMHC_VISIT') 
        } else {
            const companyId = this.props && this.props.visitFilterOptions && this.props.visitFilterOptions.filterByCompany ? this.props.visitFilterOptions.filterByCompany : this.props.user.companyId
            const visitNoParams = this.props.match.params.visitNo;
            let detailClaim = this.props.claims.find(claim => claim.vn == visitNoParams);

            if (detailClaim && detailClaim.t === 1) {
                let dateStartEnd = Moment(detailClaim.vd, 'DD/MM/YYYY').format("YYYYMMDD");
                let visitFilterOptions = {
                    fromDate: dateStartEnd, 
                    toDate: dateStartEnd, 
                    filterByClaimant: memberRecordId, 
                    filterByCompany: companyId,
                };
                this.props.getVisitsListAction({visitFilterOptions, accessToken, companyId}, (res, err) => {
                    if (res) {
                        let getVisits = res.visits.find(item => item.vn === visitNoParams);
                        visitId = getVisits.vid;
                        if (res.visits.length) {
                            this.props.getVisitDetailAction({accessToken, visitId}, (res2, err) => {
                                if (res2) {
                                    this.setState({
                                        detailPanelVisit: res2.visitDetail
                                    })
                                }
                            });
                        }
                    }
                });
            }
        }

    }

    maskNRIC(nric){
        if(nric && this.props.user && this.props.user.companyDetail && this.props.user.companyDetail.featuresConfig){
            const needMaskNric = this.props.user.companyDetail.featuresConfig.maskNRIC;
            const unmaskedPattern = this.props.user.companyDetail.featuresConfig.unmaskedNRICLength;
            // if(needMaskNric) return ""+nric.replace(/.(?=.{4,}$)/g, '*');
            if(needMaskNric) return ""+CommonUtility.maskString(nric, {unmaskedPattern});
        }
        return nric;
    }

    toTwoDecimalPlaces(amount) {
        return parseFloat(Math.round(amount * 100) / 100).toFixed(2)
    }

    renderPanelVisitDiagnosis(diagnoses){
        let diagnosis = (diagnoses||[]).filter(Boolean)
        if(diagnosis && diagnosis.length){
            return (
                <>
                    <Header as='h4' attached='top' block>
                        Diagnosis
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                            { diagnosis.map((d) => {
                                return (
                                    <Table.Row>
                                        <Table.Cell>
                                            d
                                        </Table.Cell>
                                        <Table.Cell>
                                            {''}
                                        </Table.Cell>
                                    </Table.Row>
                                )   
                            })}
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )
        }
    }

    renderPanelVisitLabs(labs){
        let lab = (labs||[]).filter(Boolean)
        if(lab && lab.length){
            return (
                <>
                    <Header as='h4' attached='top' block>
                        Labs
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                            { lab.map((d) => {
                                return (
                                    <Table.Row>
                                        <Table.Cell>
                                            {d.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            { d.amount &&
                                            <>
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(d.amount)}
                                            </> }
                                        </Table.Cell>
                                    </Table.Row>
                                )   
                            })}
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )
        }
    }

    renderPanelVisitXrays(xrays){
        let xray = (xrays||[]).filter(Boolean)
        if(xray && xray.length){
            return (
                <>
                    <Header as='h4' attached='top' block>
                        X-Rays
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                            { xray.map((d, idx) => {
                                return (
                                    <Table.Row key={idx+d.name}>
                                        <Table.Cell>
                                            {d.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            { d.amount &&
                                            <>
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(d.amount)}
                                            </> }
                                        </Table.Cell>
                                    </Table.Row>
                                )   
                            })}
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )
        }
    }

    renderPanelVisitDrugs(drugs){
        let drug = (drugs||[]).filter(Boolean)
        if(drug && drug.length){
            return (
                <>
                    <Header as='h4' attached='top' block>
                        Drugs
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                            { drug.map((d, idx) => {
                                return (
                                    <Table.Row key={idx+d.name}>
                                        <Table.Cell>
                                            {d.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            { d.amount &&
                                            <>
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(d.amount)}
                                            </> }
                                        </Table.Cell>
                                    </Table.Row>
                                )   
                            })}
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )
        }
    }

    renderPanelVisitProcedures(procedures){
        let procedure = (procedures||[]).filter(Boolean)
        if(procedure && procedure.length){
            return (
                <>
                    <Header as='h4' attached='top' block>
                        Procedures
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                            { procedure.map((d, idx) => {
                                return (
                                    <Table.Row key={idx+d.name}>
                                        <Table.Cell>
                                            {d.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            { d.amount &&
                                            <>
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(d.amount)}
                                            </> }
                                        </Table.Cell>
                                    </Table.Row>
                                )   
                            })}
                            </Table.Body>
                        </Table>
                    </Segment>
                </>
            )
        }
    }

    renderInvoice(){
        if(this.props.products && this.props.products.invoice) {
            return (
            <iframe 
                src={`data:application/pdf;base64,${this.props.products.invoice}`} 
                height="850" 
                width="100%" 
                frameBorder="0">
            </iframe>
            )
        }  
        
        return;
    }

    renderPanelVisit(selectedVisitDetail) {
        const { nric } = this.props.user;
        const { patientName, patientNric, visitNo, visitDate, statusType, paymentType, stripeChargeAmount, visitTypeString, mcDay, mcReason, mcStartDate, diagnoses, labs, xrays, drugs, procedures, referralFees, totalReferralFee, consultFee, drugFee, prescriptionFee, procedureFee, labFee, xrayFee, isGst, totalB4Gst, gst, totalFee, _id} = selectedVisitDetail;
        const mainNric =  nric.toUpperCase() != patientNric.toUpperCase() ?  nric.toUpperCase() : null;

        return (
            <Grid columns={2}>
                <Grid.Column>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>
                                        Patient Name
                                    </Table.Cell>
                                    <Table.Cell>
                                        { patientName }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Patient NRIC/FIN/Passport No.
                                    </Table.Cell>
                                    <Table.Cell>
                                        {patientNric ? this.props.configBenefit.featuresConfig.maskNRIC ? this.maskNRIC(patientNric) : patientNric : ' '}
                                    </Table.Cell>
                                </Table.Row>
                                {mainNric && 
                                <Table.Row>
                                    <Table.Cell>
                                        Main NRIC/FIN/Passport No.
                                    </Table.Cell>
                                    <Table.Cell>
                                        {mainNric ? this.props.configBenefit.featuresConfig.maskNRIC ? this.maskNRIC(mainNric) : mainNric : ' '}
                                    </Table.Cell>
                                </Table.Row> }
                                <Table.Row>
                                    <Table.Cell>
                                        Visit ID.
                                    </Table.Cell>
                                    <Table.Cell>
                                        { visitNo }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Date of Visit
                                    </Table.Cell>
                                    <Table.Cell>
                                        { visitDate }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Status
                                    </Table.Cell>
                                    <Table.Cell>
                                        { statusType }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Payment Mode
                                    </Table.Cell>
                                    <Table.Cell>
                                        { paymentType }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Total Amount
                                    </Table.Cell>
                                    <Table.Cell>
                                        { stripeChargeAmount &&
                                            <>
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(stripeChargeAmount)}
                                            </> }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Visit Type
                                    </Table.Cell>
                                    <Table.Cell>
                                        { visitTypeString }
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                    {mcDay != 0 && this.props.configBenefit.featuresConfig.showMHC &&
                    <>
                        <Header as='h4' attached='top' block>
                            MEDICAL CERTIFICATE (MC)
                        </Header>
                        <Segment attached>
                            <Table fixed>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell>
                                            No. of Days
                                        </Table.Cell>
                                        <Table.Cell>
                                            {mcDay.toString()}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Reason
                                        </Table.Cell>
                                        <Table.Cell>
                                            {mcReason}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            Start Date
                                        </Table.Cell>
                                        <Table.Cell>
                                            {mcStartDate}
                                        </Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </> }
                    { diagnoses && diagnoses.length && this.props.configBenefit.featuresConfig.showDiagnosis && this.renderPanelVisitDiagnosis(diagnoses)}
                    { labs && labs.length && this.props.configBenefit.featuresConfig.showLabs && this.renderPanelVisitLabs(labs)}
                    { xrays && xrays.length && this.props.configBenefit.featuresConfig.showXrays && this.renderPanelVisitXrays(xrays)}
                    { procedures && procedures.length && this.props.configBenefit.featuresConfig.showProcedures && this.renderPanelVisitProcedures(procedures)}
                    { drugs && drugs.length && this.props.configBenefit.featuresConfig.showDrugs && this.renderPanelVisitDrugs(drugs)}
                    <Header as='h4' attached='top' block>
                        Payment Details
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                                { parseInt(consultFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Consultation Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(consultFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(drugFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Total Drugs Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(drugFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(prescriptionFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Prescription Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(prescriptionFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(procedureFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Total Procedures Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(procedureFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(labFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Total Labs Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(labFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(xrayFee) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Total X-Rays Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(xrayFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { referralFees && referralFees.length &&
                                <Table.Row>
                                    <Table.Cell>
                                        Referral Fee
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(totalReferralFee)}
                                    </Table.Cell>
                                </Table.Row> }
                                { isGst == "Y" &&
                                <>
                                    <Table.Row>
                                        <Table.Cell>
                                            <div style={{fontWeight:'bold'}}>
                                                Total Amount Before GST
                                            </div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color='green' horizontal>SGD</Label>
                                            {this.toTwoDecimalPlaces(totalFee == stripeChargeAmount ? totalB4Gst : totalB4Gst - consultFee)}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell>
                                            <div style={{fontWeight:'bold'}}>
                                                GST
                                            </div>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Label color='green' horizontal>SGD</Label>
                                            {this.toTwoDecimalPlaces(totalFee == stripeChargeAmount ? gst : gst - consultFee * (gst / totalB4Gst))}
                                        </Table.Cell>
                                    </Table.Row> 
                                </> }
                                <Table.Row>
                                    <Table.Cell>
                                        <div style={{fontWeight:'bold'}}>
                                            {isGst == "Y" ? 'Total Amount After GST' : "Total Amount"}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell>
                                        { stripeChargeAmount && 
                                        <>
                                            <Label color='green' horizontal>SGD</Label>
                                            {this.toTwoDecimalPlaces(stripeChargeAmount)}
                                        </> }
                                    </Table.Cell>
                                </Table.Row> 
                            </Table.Body>
                        </Table>
                    </Segment>
                </Grid.Column>
                { this.props.configBenefit.featuresConfig.showReceipt &&
                <Grid.Column>
                    <Segment.Group>
                        <Header as='h4' attached='top' block>
                            Proof of Visit
                        </Header>
                        <Segment attached>
                            {this.renderInvoice()}
                        </Segment>
                    </Segment.Group>
                </Grid.Column> }
            </Grid>
        )
    }

    renderVisitIncurreDetail(selectedVisitDetail) {
        const { patientName, patientNric, visitNo, visitDate, statusType, paymentType, stripeChargeAmount, visitTypeString, mcDay, mcReason, mcStartDate, diagnoses, labs, xrays, drugs, procedures, referralFees, totalReferralFee, consultFee, drugFee, prescriptionFee, procedureFee, labFee, xrayFee, isGst, totalB4Gst, gst, totalFee, _id} = selectedVisitDetail;
        
        return (
            <div>
                {/* Consultation Fee */}
                <Grid columns={2}>
                    <Grid.Column verticalAlign='left'>Consultation Fee</Grid.Column>
                    <Grid.Column verticalAlign='right'>
                        <Label color='green' horizontal>SGD</Label>
                        {this.toTwoDecimalPlaces(consultFee)}
                    </Grid.Column>
                </Grid>

                {/* Total Drugs Fee */}
                <Grid columns={2}>
                    <Grid.Column verticalAlign='left'>{'Total Medication(s)'}</Grid.Column>
                    <Grid.Column verticalAlign='right'>
                        <Label color='green' horizontal>SGD</Label>
                        {this.toTwoDecimalPlaces(drugFee)}
                    </Grid.Column>
                </Grid>

                {/* Total Procedures Fee */}
                <Grid columns={2}>
                    <Grid.Column verticalAlign='left'>{'Total Investigation(s)'}</Grid.Column>
                    <Grid.Column verticalAlign='right'>
                        <Label color='green' horizontal>SGD</Label>
                        {this.toTwoDecimalPlaces(procedureFee + labFee + xrayFee)}
                    </Grid.Column>
                </Grid>

                {/* GST */}
                { isGst == "Y" ? (
                    <Grid columns={2}>
                        <Grid.Column verticalAlign='left'>GST</Grid.Column>
                        <Grid.Column verticalAlign='right'>
                            <Label color='green' horizontal>SGD</Label>
                            {gst ? this.toTwoDecimalPlaces(gst) : 0}
                        </Grid.Column>
                    </Grid>
                ) : null}
            </div>
        )
    }

    renderClaimRecord(selectedVisitDetail) {
        const { nric, companyName } = this.props.user;
        const { ca, ia, d, ic, n, p, pa, t, vd, vn} = selectedVisitDetail;
        let z = 0;
        var multipleDiagnosis = '';
       
        if (d) {
            d.forEach(function(_diagnosis) {
                if (multipleDiagnosis == '') {
                    multipleDiagnosis += _diagnosis;
                } else {
                    multipleDiagnosis += ', ' + _diagnosis;
                }
            });
        }

        return (
            <Grid columns={2}>
                <Grid.Column>
                    <Header as='h4' attached='top' block>
                        Claimant
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>
                                        Company
                                    </Table.Cell>
                                    <Table.Cell>
                                        {companyName}
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Name
                                    </Table.Cell>
                                    <Table.Cell>
                                        {n}
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        NRIC
                                    </Table.Cell>
                                    <Table.Cell>
                                        {this.maskNRIC(ic)}
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                    <Header as='h4' attached='top' block>
                        Claim Details
                    </Header>
                    <Segment attached>
                        <Table fixed>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell>
                                        Visit No
                                    </Table.Cell>
                                    <Table.Cell>
                                        {vn}
                                    </Table.Cell>
                                </Table.Row>
                                { parseInt(ia) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Incurred Amount
                                    </Table.Cell>
                                    <Table.Cell className='d-flex flex-row'>
                                        <Grid columns={2}>
                                            <Grid.Column verticalAlign='left' >
                                                <Label color='green' horizontal>SGD</Label>
                                                {this.toTwoDecimalPlaces(ia)}
                                            </Grid.Column>
                                                <Grid.Column verticalAlign='right' >
                                                    { this.state.detailPanelVisit && this.state.detailPanelVisit.checkupFee 
                                                    ? null
                                                    : <Label style={{cursor:'pointer'}} color='gray' horizontal onClick={() => this.setState({showDetailIncAmount: !this.state.showDetailIncAmount})}>Show Detail</Label>
                                                    }
                                            </Grid.Column>
                                        </Grid>
                                    </Table.Cell>
                                </Table.Row> }
                                {this.state.showDetailIncAmount ? (
                                    <Table.Row>
                                        <Table.Cell colSpan='2'>
                                            <div style={{borderRadius: 10, backgroundColor: '#EAEAEA', padding: 20}}>
                                                {
                                                    this.state.detailPanelVisit &&
                                                    (this.props.configBenefit.featuresConfig.itemizedMonth !== null || this.props.configBenefit.featuresConfig.itemizedMonth !== '') && 
                                                    Moment() >= Moment(selectedVisitDetail.vd, 'DD/MM/YYYY').add(this.props.configBenefit.featuresConfig.itemizedMonth, 'months') ? 
                                                    this.renderVisitIncurreDetail(this.state.detailPanelVisit) : 
                                                    <p>{this.props.configBenefit.featuresConfig.itemizedMessage}</p>
                                                }
                                            </div>
                                        </Table.Cell>
                                    </Table.Row>
                                ) : null}
                                { parseInt(pa) != 0 &&
                                <Table.Row>
                                    <Table.Cell>
                                        Payable Amount
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(pa)}
                                    </Table.Cell>
                                </Table.Row> }
                                { parseInt(ca) != 0 && 
                                <Table.Row>
                                    <Table.Cell>
                                        Claimable Amount
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Label color='green' horizontal>SGD</Label>
                                        {this.toTwoDecimalPlaces(ca)}
                                    </Table.Cell>
                                </Table.Row> }
                                <Table.Row>
                                    <Table.Cell>
                                        Diagnosis/Medical Condition
                                    </Table.Cell>
                                    <Table.Cell>
                                        {multipleDiagnosis}
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Visit Date
                                    </Table.Cell>
                                    <Table.Cell>
                                        { Moment(vd, 'D/M/YYYY').format('DD MMM YYYY') }
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Provider Name
                                    </Table.Cell>
                                    <Table.Cell>
                                        {p}
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        Remarks
                                    </Table.Cell>
                                    <Table.Cell>
                                        {'No Remarks'}
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                </Grid.Column>
            </Grid>
        )
    }

    render() {
        const visitNoParams = this.props.match.params.visitNo;
        const visitIdParams = this.props.match.params.visitId;
        const selectedVisitDetail = visitIdParams !== 'detail' ? this.props.viewedClaims[visitNoParams] : this.props.claims.find( claim => claim.vn == visitNoParams);
        
        if (!selectedVisitDetail) {
            return (
                <Loader active />
            );
        }

        return (
            <Container fluid>
                <Header as='h2' attached='top' block>
                    {(visitNoParams) ? "Visit Details - " + visitNoParams : "Visit Details "}
                </Header>
                <Segment>
                    <Link to="/app/visits">
                        <Button>
                            Back to My Visits
                        </Button>
                    </Link>
                </Segment>
                {this.renderClaimRecord(selectedVisitDetail)}
           </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        viewedClaims: state.claims.viewed,
        claims: state.claims.data,
        claimFilterOptions: state.claims.filterOptions,
        configBenefit: state.user.configBenefit,
        products: state.products,
    }
}

export default connect(mapStateToProps, {
    getVisitDetailAction, 
    getVisitsListAction, 
    generateInvoice 
})(PanelVisitDetailPage);
